export const data = {
    domainFb: '/landing/',
    domainTt: '/landing-tt/',

    fieldsFb: '&pid=metaweb_int&af_ad_id={{ad.id}}&af_adset_id={{adset.id}}&af_c_id={{campaign.id}}&c={{campaign.name}}&af_ad={{ad.name}}&af_adset={{adset.name}}',
    fieldsTt: '&pid=tiktokweb&af_siteid=__CSITE__&c=__CAMPAIGN_NAME__&af_channel=__PLACEMENT__&af_c_id=__CAMPAIGN_ID__&af_adset=__AID_NAME__&af_adset_id=__AID__&af_ad=__CID_NAME__&af_ad_id=__CID__&af_ad_type=__CTYPE__&af_click_lookback=7d&&ttclid=__CALLBACK_PARAM__&af_sub5=__CALLBACK_PARAM__&os=__OS__&af_ip=__IP__&af_ua=__UA__&af_lang=__SL__'
}